export const UMB_SLUG = '/document-blueprint';
